import { app } from "@/config/env";
import { SENTRY_IGNORE_STRS } from "@/constants/sentry";
import { isLocal } from "@/lib/utils";
import * as Sentry from "@sentry/react";

export function init(): void {
  if (isLocal) {
    return;
  }

  if (app.SENTRY_DSN) {
    Sentry.init({
      environment: app.ENV,
      dsn: app.SENTRY_DSN,
      tracesSampleRate: 1.0,
      beforeSend: (event) => {
        const message = event.exception?.values?.[0]?.value?.toLowerCase() ?? "";
        if (SENTRY_IGNORE_STRS.some((str) => message.includes(str))) {
          return null;
        }
        return event;
      },
    });
  }
}

type SentryCaptureExceptionOptions = Parameters<typeof Sentry.captureException>[1];

export function collectError(error: unknown, options?: SentryCaptureExceptionOptions): void {
  if (isLocal) {
    return;
  }

  Sentry.captureException(error, options);
}

export function setUserContext(id: string, email: string): void {
  Sentry.setUser({
    id,
    email,
  });
}

export function resetUserContext() {
  Sentry.setUser(null);
}

export function setRoutePath(path: string) {
  Sentry.setTag("route.url", window.location.href);
  Sentry.setTag("route.path", path);
}

export { Sentry };
